<template>
  <div class="bbp-hashtag-cell">
    <div
      v-for="{name, color, _id} in showItems"
      :key="_id"
      class="bbp-hashtag-cell-item"
      @click.stop="onFilterTag(_id)"
      :style="{
        color: `rgba(${color}, 1)`,
        background: `rgba(${color}, 0.15)`
      }"
    >
      {{name}}
    </div>
    <div
      v-if="otherItems.length"
      class="bbp-hashtag-cell__text"
      @click.stop="onShowMore($event)"
    >
      + {{otherItems.length}} more
    </div>
    <transition name="bbp-bounce">
      <div
        v-if="isShowPopup"
        class="bbp-hashtag-cell-popup"
        :style="popupPosition"
        @mouseleave="isShowPopup = false"
      >
        <div
          class="bbp-hashtag-cell-item"
          v-for="{name, color, _id} in otherItems"
          :key="_id"
          @click.stop="onFilterTag(_id)"
          :style="{
            color: `rgba(${color}, 1)`,
            background: `rgba(${color}, 0.15)`
          }"
        >
          {{name}}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import {difference} from 'lodash'

export default {
  name: 'HashtagCell',
  props: {
    items: {
      type: Array,
      default: () => ([])
    },
    column: {
      type: Object,
      default: () => ({})
    },
    rowId: {
      type: String,
      default: ''
    },
    columnId: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    widthFree: null,
    isShowPopup: false,
    popupPosition: {}
  }),
  computed: {
    showItems () {
      if (!this.widthFree) return
      const currentIndex = this.items.findIndex((el) => el.length > this.widthFree)
      if (currentIndex === -1) return this.items
      return this.items.slice(0, currentIndex)
    },
    otherItems () {
      if (!this.widthFree) return []
      return difference(this.items, this.showItems)
    }
  },
  methods: {
    checkLengths () {
      const par = document.getElementById(`bbp-string-cell-id_${this.rowId}_${this.columnId}`)
      if (!par) return
      const valueLengths = par.offsetWidth
      const marginLengths = 105
      const column = document.getElementById(`${this.columnId}`)
      this.widthFree = column.offsetWidth - (marginLengths + valueLengths)
    },
    onShowMore ({target}) {
      this.isShowPopup = !this.isShowPopup
      const {top, left, height} = target.getBoundingClientRect()
      this.popupPosition = {
        position: 'fixed',
        top: `${top + height}px`,
        left: `${left}px`
      }
    },
    onFilterTag (id) {
      this.$emit('onFilterTag', id)
    }
  },
  mounted () {
    this.checkLengths()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

  .bbp-hashtag-cell {
    display: flex;
    grid-gap: 8px;
    margin: 0 0 0 8px;

    &__text {
      width: max-content;
      position: relative;
      padding-top: 2px;
      font-weight: 500;
      font-size: 12px;
      line-height: 150%;
      color: #B9B9B9;
      cursor: pointer;
    }
  }

  .bbp-hashtag-cell-item {
    padding: 4px 6px 4px 6px;
    width: max-content;
    border-radius: 4px;
    color: $color-denim;
    font-size: 13px;
    line-height: 16px;
    background: rgba($color-denim, 0.14);
    cursor: pointer;
  }

  .bbp-hashtag-cell-popup {
    display: grid;
    grid-gap: 8px;
    background: $color-alabaster;
    box-shadow: 0 0 12px rgba($color-black, 0.12);
    border-radius: 4px;
    padding: 12px;
    z-index: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPStringCell/HashtagCell.vue